<div class="d-flex flex-column flex-fill dx-card">
  <div class="d-flex flex-row justify-content-center" style="max-height: 40px">
    @for (arTotal of arTotals; track arTotal) {
      <div class="ar-block" (click)="openARTotal(arTotal)">
        <div class="ar-header">{{ arTotal.Name }}</div>
        <div class="ar-amount">{{ arTotal.Amount | currency }}</div>
      </div>
    }
  </div>
  <div class="d-flex flex-row flex-fill p-2">
    <div class="d-flex flex-column flex-fill p-1">
      <dx-data-grid
        #invoiceGrid
        class="flex-fill d-flex flex-column"
        height="650px"
        [dataSource]="arAging"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        [columnAutoWidth]="false"
        >
        <dxi-data-grid-column dataField="CustomerId" caption="Id" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="CompanyName" caption="Customer" width="365" cellTemplate="customerLinkTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="CreatedPreDec16" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="CurrentDue" [format]="{ type: 'currency', precision: 2 }" width="115"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="Net30" caption="1-30" [format]="{ type: 'currency', precision: 2 }" width="115"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="Net60" caption="31-60" [format]="{ type: 'currency', precision: 2 }" width="115"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="Net90" caption="61-90" [format]="{ type: 'currency', precision: 2 }" width="115"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="Net90Plus" caption="90+" [format]="{ type: 'currency', precision: 2 }" width="115"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="Total" [format]="{ type: 'currency', precision: 2 }" width="115"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <div *dxTemplate="let cell of 'customerLinkTemplate'">
          @if (cell) {
            <a [routerLink]="'/customers/' + cell.data.CustomerId" [innerHtml]="cell.text"></a>
          }
        </div>

        <div *dxTemplate="let data of 'toolbarHeaders'">
          <h4 class="m-0">Invoices</h4>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (invoiceGrid) {
            <span class="me-3">
              <strong>{{ invoiceGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>

        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-selection [mode]="'single'"></dxo-data-grid-selection>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="ar-aging-grid"></dxo-data-grid-state-storing>

        <dxo-data-grid-summary>
          <dxi-data-grid-total-item
            column="CurrentDue"
            summaryType="sum"
            [displayFormat]="'{0}'"
            [valueFormat]="{ type: 'currency', precision: 2 }"
            >
          </dxi-data-grid-total-item>
          <dxi-data-grid-total-item
            column="CreatedPreDec16"
            summaryType="sum"
            [displayFormat]="'{0}'"
            [valueFormat]="{ type: 'currency', precision: 2 }"
            >
          </dxi-data-grid-total-item>
          <dxi-data-grid-total-item
            column="Net30"
            summaryType="sum"
            [displayFormat]="'{0}'"
            [valueFormat]="{ type: 'currency', precision: 2 }"
            >
          </dxi-data-grid-total-item>
          <dxi-data-grid-total-item
            column="Net60"
            summaryType="sum"
            [displayFormat]="'{0}'"
            [valueFormat]="{ type: 'currency', precision: 2 }"
            >
          </dxi-data-grid-total-item>
          <dxi-data-grid-total-item
            column="Net90"
            summaryType="sum"
            [displayFormat]="'{0}'"
            [valueFormat]="{ type: 'currency', precision: 2 }"
            >
          </dxi-data-grid-total-item>
          <dxi-data-grid-total-item
            column="Total"
            summaryType="sum"
            [displayFormat]="'{0}'"
            [valueFormat]="{ type: 'currency', precision: 2 }"
            >
          </dxi-data-grid-total-item>
          <dxi-data-grid-total-item
            column="Net90Plus"
            summaryType="sum"
            [displayFormat]="'{0}'"
            [valueFormat]="{ type: 'currency', precision: 2 }"
            >
          </dxi-data-grid-total-item>
        </dxo-data-grid-summary>
      </dx-data-grid>
    </div>
  </div>
</div>
